import { Components, Theme } from "@mui/material"

export const MuiIconButton: Required<Components<Theme>>["MuiIconButton"] = {
  styleOverrides: {
    root: ({ theme: { palette } }) => ({
      color: palette.action.active,
    }),
  },
}
